module.exports = __webpack_public_path__ + "static/media/mr-l200.a70cb735.webp";